"use strict";

var _taggedTemplateLiteral = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

require("core-js/modules/es6.object.assign");

var _slicedToArray = require("/Users/sammarks/Code/website/node_modules/@babel/runtime/helpers/slicedToArray");

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.symbol");

require("core-js/modules/es6.array.index-of");

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  align-self: flex-start;\n  .rdtPicker {\n    box-shadow: none;\n    border: none;\n    padding: 0;\n    margin-top: 0;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  box-shadow: none !important;\n  border: none !important;\n  padding: 0 !important;\n  margin-top: 0 !important;\n  position: static !important;\n  display: block !important;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .ant-popover-inner-content {\n    padding: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DateTimePicker = void 0;

var antd_1 = require("antd");

var react_1 = __importDefault(require("react"));

var react_datetime_1 = __importDefault(require("react-datetime"));

var react_dom_1 = require("react-dom");

var styled_components_1 = __importDefault(require("styled-components"));

var AntStyled_1 = require("./AntStyled");

function DateTimePicker(_a) {
  var inputProps = _a.inputProps,
      disabled = _a.disabled,
      closeOnSelect = _a.closeOnSelect,
      props = __rest(_a, ["inputProps", "disabled", "closeOnSelect"]);

  require('react-datetime/css/react-datetime.css');

  var _react_1$default$useS = react_1["default"].useState(false),
      _react_1$default$useS2 = _slicedToArray(_react_1$default$useS, 2),
      open = _react_1$default$useS2[0],
      setOpen = _react_1$default$useS2[1];

  var _react_1$default$useS3 = react_1["default"].useState(null),
      _react_1$default$useS4 = _slicedToArray(_react_1$default$useS3, 2),
      container = _react_1$default$useS4[0],
      setContainer = _react_1$default$useS4[1];

  var canClose = react_1["default"].useRef(false);
  react_1["default"].useEffect(function () {
    if (open) {
      canClose.current = false;
      var handle = setTimeout(function () {
        canClose.current = true;
      }, 500);
      return function () {
        return clearTimeout(handle);
      };
    } else {
      canClose.current = false;
    }
  }, [open]);
  return react_1["default"].createElement(Pop, {
    content: react_1["default"].createElement(PopoverPicker, {
      className: 'rdtPicker',
      ref: function ref(c) {
        return setContainer(c);
      },
      onClickCapture: function onClickCapture() {
        /**
         * This is some fun BS; because we're rendering the contents in a portal (which we have to do
         * so the date picker appears in a different layer and can therefore appear above the Tour mask
         * like all of the other Ant overlays), the click events inside here are triggering the Ant
         * popover to close. So we need to (upon capturing a click event) tell Ant that it actually can't
         * close the overlay, and then reset that an instant later.
         */
        canClose.current = false;
        requestAnimationFrame(function () {
          canClose.current = true;
        });
      }
    }),
    visible: open && !disabled,
    onVisibleChange: function onVisibleChange(v) {
      if (canClose.current && !v) {
        setOpen(v);
      } else if (v) {
        setOpen(v);
      }
    },
    trigger: ['click']
  }, react_1["default"].createElement(Wrapper, null, react_1["default"].createElement(react_datetime_1["default"], Object.assign({
    renderInput: function renderInput(p) {
      return react_1["default"].createElement(antd_1.Input, Object.assign({}, inputProps, p, {
        onFocus: function onFocus() {
          return setOpen(true);
        }
      }));
    }
  }, props, {
    onChange: function onChange() {
      if (props.onChange) {
        props.onChange.apply(props, arguments);
      }

      if (closeOnSelect) {
        setOpen(false);
      }
    },
    open: open,
    onOpen: function onOpen() {
      return setOpen(true);
    },
    onClose: function onClose() {
      return setOpen(false);
    },
    renderView: function renderView(mode, renderDefault) {
      if (container) {
        return (0, react_dom_1.createPortal)(renderDefault(), container);
      } else {
        return react_1["default"].createElement(react_1["default"].Fragment, null);
      }
    }
  }))));
}

exports.DateTimePicker = DateTimePicker;
var Pop = (0, styled_components_1["default"])(AntStyled_1.StyledPopover)(_templateObject(), function (props) {
  return props.theme['@size-xxs'];
});
var PopoverPicker = styled_components_1["default"].div(_templateObject2());
var Wrapper = styled_components_1["default"].div(_templateObject3());